import { render } from "./ProfileView.vue?vue&type=template&id=8cbf15c0&scoped=true&ts=true"
import script from "./ProfileView.vue?vue&type=script&lang=ts"
export * from "./ProfileView.vue?vue&type=script&lang=ts"

import "./ProfileView.vue?vue&type=style&index=0&id=8cbf15c0&scoped=true&lang=css"
import "./ProfileView.vue?vue&type=style&index=1&id=8cbf15c0&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cbf15c0"]])

export default __exports__